module.exports = __webpack_public_path__ + "static/media/Daily_Pleasure2.b30c06af.mp3";